import { MediaInput, useWorkflowInput } from "ra-friendsofbabba";

import React from "react";

const DocMediaInput = (props) => {
  const { disabled } = useWorkflowInput({ ...props });
  return <MediaInput {...props} disabled={disabled} />;
};

export default DocMediaInput;
